import React from 'react';
import { FacebookShareButton, LinkedinShareButton, ViberShareButton, EmailShareButton} from 'react-share';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import classNames from 'classnames';

const styles = theme => ({
    customButton: {
        // padding: '7px 75px', 
        color: '#fff',
        width: '90%',
        height: 36
    },
    iconWrapper: {
        position: 'absolute',
        left: 10,
        background: '#fff',
        color: '#000',
        bottom: 8,
        width: 20,
        borderRadius: 5,
        height: 20,
    },
    buttonLabel:{
        [theme.breakpoints.only('xs')]: {
            marginLeft: 20
        }
    },
    textShare: {
      paddingTop: 1
    },
    btnWrapper: {
        width: '100%',
        margin: '0 auto 20px',
            [theme.breakpoints.only('xs')]: {
                width: '85%',
            }
    }
})
class ShareButtons extends React.Component{
    render() {
        const { item, url, classes } = this.props;
        // console.log(this.props)
        // console.log(url.asPath)
        // console.log(item.title)
        return(
            <Grid
                style={{ margin: '50px 0px 20px' }}
                container
                direction="row"
                justify="center"
                alignItems="center"

            >
                {/*E-Mail*/}
                <Grid item xs={6} sm={3} md={3} lg={2} style={{textAlign: 'center'}}>
                    <EmailShareButton
                      url={`${process.env.BACKEND_URL}${url.asPath}`}
                      windowWidth={750}
                      windowHeight={600}
                    >
                        <div className={classNames(classes.btnWrapper, 'email-share-btn-track-gtm')}>
                            <Button variant="contained" size="medium" color="primary" classes={{root: classes.customButton, label: classes.buttonLabel }} style={{background: '#808080'}}>
                                <div className={classes.iconWrapper}>
                                    <Icon style={{color: '#808080', fontSize: 16, paddingTop: 2}}>email</Icon>
                                </div>
                                <span className={classes.textShare}>Share</span>
                            </Button>
                        </div>
                    </EmailShareButton>
                </Grid>

                {/*Viber*/}
                <Grid item xs={6} sm={3} md={3} lg={2} style={{textAlign: 'center'}}>
                  <ViberShareButton url={`${process.env.BACKEND_URL}${url.asPath}`} title={item.title}>
                      <div className={classNames(classes.btnWrapper, 'viber-share-btn-track-gtm')}>
                          <Button variant="contained" size="medium" color="primary" classes={{root: classes.customButton, label: classes.buttonLabel }} style={{background: '#7e32b2'}}>
                              <div className={classes.iconWrapper}>
                                  <FontAwesomeIcon icon={['fab', 'viber']} style={{color: '#7e32b2'}} />
                              </div>
                              <span className={classes.textShare}>Share</span>
                          </Button>
                      </div>
                  </ViberShareButton>
                </Grid>

                {/*LinkIn*/}
                <Grid item xs={6} sm={3} md={3} lg={2} style={{textAlign: 'center'}}>
                    <LinkedinShareButton
                         url={`${process.env.BACKEND_URL}${url.asPath}`}
                         windowWidth={750}
                         windowHeight={600}
                    >
                        <div className={classNames(classes.btnWrapper, 'linkedIn-share-btn-track-gtm')}>
                            <Button variant="contained" size="medium" color="primary" classes={{root: classes.customButton, label: classes.buttonLabel }} style={{background: '#006cc6'}}>
                                <div className={classes.iconWrapper}>
                                    <FontAwesomeIcon icon={['fab', 'linkedin-in']} style={{color: '#006cc6'}} />
                                </div>
                                <span className={classes.textShare}>Share</span>
                            </Button>
                        </div>
                    </LinkedinShareButton>
                </Grid>
                
                {/*Facebook*/}
                <Grid item xs={6} sm={3} md={3} lg={2} style={{textAlign: 'center'}} >
                    <FacebookShareButton url={`${process.env.BACKEND_URL}${url.asPath}`}>
                        <div className={classNames(classes.btnWrapper, 'fb-share-btn-track-gtm')} >
                            <Button variant="contained" classes={{root: classes.customButton, label: classes.buttonLabel }} size="medium" style={{background: '#014ca9'}}>
                                <div className={classes.iconWrapper}>
                                    <FontAwesomeIcon icon={['fab', 'facebook-f']} style={{color: '#014ca9'}} />
                                </div>
                                <span className={classes.textShare}>Share</span>
                            </Button>
                        </div>
                    </FacebookShareButton>
                </Grid>

            </Grid>
        )
    }
} 

export default withStyles(styles)(ShareButtons);
